import React, { useEffect } from 'react'
import MandatoryAutoPayControl from './MandatoryAutoPayControl'
import OptionalAutoPayControl from './OptionalAutoPayControl'

const AutoPayControl = ({ enableAutoPay, setEnableAutoPay, franchisePaymentPlan }) => {
  useEffect(() => {
    switch(franchisePaymentPlan.attributes.autoPay) {
      case "required":
        setEnableAutoPay(true)
        break
      case "optional":
        setEnableAutoPay(false)
        break
      case "none":
        setEnableAutoPay(false)
        break
      default:
        throw new Error(`Invalid autoPay value: ${franchisePaymentPlan.attributes.autoPay}`)
    }
  }, [franchisePaymentPlan.attributes.autoPay])

  switch(franchisePaymentPlan.attributes.autoPay) {
    case "required":
      return <MandatoryAutoPayControl enableAutoPay={enableAutoPay} setEnableAutoPay={setEnableAutoPay} />
    case "optional":
      return <OptionalAutoPayControl enableAutoPay={enableAutoPay} setEnableAutoPay={setEnableAutoPay} />
    case "none":
      return null
    default:
      throw new Error(`Invalid autoPay value: ${franchisePaymentPlan.attributes.autoPay}`)
  }
}

export default AutoPayControl
